import React from "react";
import { Steps, Icon } from "antd";
const Step = Steps.Step;

const orderStatus = [
  "created",
  "collectingData",
  "validatingData",
  "inProcess",
  "sent",
  "completed",
  "canceled"
];

class OrderProgress extends React.Component {
  render() {
    const { status } = this.props;
    return (
      <Steps
        style={{ margin: "24px 0" }}
        size="small"
        current={orderStatus.indexOf(status) - 1}
      >
        {/* <Step
          title="Creado"
          icon={<Icon type="file-add" />}
          description="Orden generada con éxito"
        /> */}
        <Step
          title="Recopilando Datos"
          icon={<Icon type="edit" />}
          description={
            <span className="orders__progress-description">
              Datos para el servicio
            </span>
          }
        />
        <Step
          title="Validando Datos"
          icon={<Icon type="safety" />}
          description={
            <span className="orders__progress-description">
              Verificando datos proporcionados
            </span>
          }
        />
        <Step
          title="En Proceso"
          icon={<Icon type="sync" />}
          description={
            <span className="orders__progress-description">
              Trabajando la orden
            </span>
          }
        />
        <Step
          title="Enviado"
          icon={<Icon type="share-alt" />}
          description={
            <span className="orders__progress-description">
              Se ha enviado una respuesta
            </span>
          }
        />
        <Step
          title="Terminado"
          icon={<Icon type="flag" />}
          description={
            <span className="orders__progress-description">
              Servicio completado
            </span>
          }
        />
      </Steps>
    );
  }
}

export default OrderProgress;



// WEBPACK FOOTER //
// ./src/Components/Orders/OrderProgress.js